import { useState, useEffect } from "react";
import {
    Box, Flex, Badge, useToast,
    Text, SimpleGrid
} from "@chakra-ui/react";

import CommonService from "../services/CommonService";
import { formatDate } from "../utils/helper";

const Transactions = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    const [data, setData] = useState([]);
    const toast = useToast();

    const paymentList = async () => {
        try {
            const res = await CommonService.getUserTransaction({
                uId: user.uId,
                authToken: user.authToken,
            });
            if (res.statusCode === 200) setData(res.data);
        } catch (error) {
            const er = error.response?.data?.message || "Something went wrong";
            toast({
                title: 'Error',
                description: er,
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
            });
        }
    };

    useEffect(() => {
        paymentList();
    }, []);

    return (
        <Box maxW="1000px" mx="auto" px={4}>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
                {data.map((item) => (
                    <Box
                        key={item.billId}
                        p={3}
                        borderWidth="1px"
                        borderRadius="lg"
                        boxShadow="sm"
                        bg="white"
                    >
                        <Flex justify="space-between" align="center" mb={2}>
                            <Text fontWeight="bold">{item.plan}</Text>
                            <Badge colorScheme="teal">{item.mode}</Badge>
                        </Flex>

                        <Flex justify="space-between" align="center" mb={2}>
                            <Text fontSize="sm" color="gray.600">{formatDate(item.FrmDt)} to {formatDate(item.ToDt)}</Text>
                            <Text fontWeight="bold">
                                ₹ {item.rate}
                            </Text>
                        </Flex>
                    </Box>
                ))}
            </SimpleGrid>

        </Box>


    );
};

export default Transactions;
